export const URI_MODULE = 'template/module';
export const URI_CREATE_WORKSHOP_MODULE = 'workshop/module';
